export default __webpack_public_path__ + "static/media/excel.ad9552cc.pdf";